import { Link } from 'react-router-dom';
import { comics } from '@/mocks/manga';
import { latestUpdates } from '@/mocks/featured';

export default function LatestSection() {
  const latest = latestUpdates.map(id => comics.find(c => c.id === id)).filter(Boolean) as typeof comics;

  return (
    <section className="w-full bg-background-50 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">最新更新</h2>
            <p className="text-sm text-foreground-500 mt-1">实时追踪，永不掉队</p>
          </div>
          <Link to="/category/lianzai" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1 cursor-pointer">
            查看更多 <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {latest.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex items-center gap-4 p-4 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              data-product-shop
            >
              <div className="relative flex-shrink-0 w-16 h-20 rounded-md overflow-hidden">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 古古漫画网`}
                  title={`${comic.title} - ${comic.tags.join(' ')}`}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-1 left-1 w-5 h-5 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-[10px] font-bold">
                  {index + 1}
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                <div className="flex items-center gap-2 mt-1.5">
                  <span className={`text-[11px] px-1.5 py-0.5 rounded ${
                    comic.status === '连载' ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {comic.status}
                  </span>
                  <span className="text-[11px] text-foreground-400">
                    {comic.updateDate}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}